export default __webpack_public_path__ + "static/media/EDO-kompas.74ec2b1c.jpg";